export var randomNumber = function(length){
  return Math.random().toString().slice(2,2 + length);
}

export var removeObjectAfterTime = function(obj, time){
  if (time > 0){
    setTimeout(function () {
      $(obj).remove();
    }, time);
  }
}

export function getInstanceId(){
  return $("#instance-id").val()
}

export function getCourseId(){
  return $("#course-id").val()
}

export var successMessage = function(holder, mes, time_alive=10000){
  const id = randomNumber(3);
  $(holder).prepend('<div class="alert success message-' + id + '"><div class="alert_body"><i class="icon-check"></i> ' + mes + ' </div><div class="alert_close"><i class="icon_close"></i></div></div>').fadeIn('fast')
  removeObjectAfterTime(`.message-${id}`, time_alive);
}

export var errorMessage = function(holder, mes, time_alive=10000){
  const id = randomNumber(3);
  $(holder).prepend('<div class="alert error message-' + id + '"><div class="alert customize-alert alert-dismissible alert-light-danger text-danger fade show remove-close-icon" role="alert">\n' +
    '                                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close">\n' +
    '                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x fill-white text-danger feather-sm"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>\n' +
    '                                    </button>\n' +
    '                                    <div class="d-flex align-items-center font-weight-medium me-3 me-md-0">\n' +
    '                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info text-danger fill-white feather-sm me-2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="8"></line></svg>' + mes + ' </div></div></div>').fadeIn('fast')
  removeObjectAfterTime(`.message-${id}`, time_alive);
}

export var alertMessage = function(holder, mes, time_alive=10000){
  const id = randomNumber(3);
  $(holder).prepend('<div class="alert info message-' + id + '"><div class="alert_body"><i class="icon-info"></i>' + mes + '</div></div>').fadeIn('fast');
  removeObjectAfterTime(`.message-${id}`, time_alive);
}

export var toastOptions = function(duration=10000, progressbar=false){
  return {
    "closeButton": true,
    "debug": false,
    "newestOnTop": true,
    "progressBar": progressbar,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "0",
    "timeOut": duration,
    "extendedTimeOut": "0",
    "showEasing": "swing",
    "hideEasing": "swing",
    "showMethod": "fadeIn",
    "hideMethod": "slideUp"
  }
}

export var successToast = function(text, headline='Erfolg', duration=5000, progressbar=false){
  toastr.success(text, "Erfolg", toastOptions(duration, progressbar));
}

export function errorToast(headline, text="Fehler", duration=0, progressbar=false){
  toastr.error(headline, text, toastOptions(duration, progressbar));
}

export var infoToast = function(headline, text, duration=10000, progressbar=false){
  toastr.info(headline, text, toastOptions(duration, progressbar));
}

export var warningToast = function(headline, text, duration=10000, progressbar=false){
  toastr.warning(headline, text, toastOptions(duration, progressbar));
}

export var resendMailToast = function(text, headline='', duration=0){
  const options = toastOptions(duration);
  options.tapToDismiss = false;
  toastr.error(text, headline, options);
}


export var logError = function(mes){
  $.ajax({
    url: pexam_ajax_object.ajax_url,
    type: "POST",
    data: {
      action: "log_error",
      _ajax_nonce: pexam_ajax_object.nonce,
      message: mes,
    }
  });
}


export var displayRegistrationError = function(item){
  $('.' + item.id).next().next().html(item.error).show();
}

export var checkEmail = function(email){
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export var hideModal = function(modalId){
  const modal = bootstrap.Modal.getInstance( document.getElementById(modalId))
  modal.hide();
}

export var showModal = function(modalId){
  const myModal = new bootstrap.Modal(document.getElementById(modalId))
  myModal.show();
}

export var showLogin = function(username=false){
  const myModal = new bootstrap.Modal(document.getElementById('login-modal'))
  if (username){
    $("#login-email").val(username);
    document.getElementById("login-password").focus();
  } else {
    document.getElementById("login-email").focus();
  }
  myModal.show();

}

export var turnDanger = function(field){
  field.addClass('is-invalid');
  field.parent().addClass('has-danger');
}

export var displayErrors = function(errors, time=0){
  errors.forEach(item => errorToast(item, "Fehler", time, true));
}

export var checkEmailVornameNachname = function(mail, vorname, nachname){
  let status = true;
  // 1. Vor + Nachname
  if (vorname == ''){
    status = false;
    turnDanger($("#vorname"));
    errorToast('Bitte gib einen Vornamen an', 'Fehler', 12500, true);
  }
  if (nachname == ''){
    status = false;
    turnDanger($("#nachname"));
    errorToast('Bitte gib einen Nachnamen an', 'Fehler', 12500, true);
  }
  // 2. Email
  if (mail == '' || mail == undefined || !checkEmail(mail)){
    status = false;
    turnDanger($("#email"));
    errorToast('Bitte gib eine gülitge E-Mail-Adresse an', 'Fehler', 12500, true);
  }
  return status;
}

export var displayQuestionAnswer = function(headline:string, content:string){

  const wrapper = $("#offCanvasHelp")
  wrapper.find(".offcanvas-title").html(headline);
  wrapper.find(".offcanvas-content").html(content);
}

export var createOffCanvas = function(){
  const canvas = document.getElementById("offCanvasHelp");
  if (canvas == undefined) {
    const c = document.createElement('div');
    c.classList.add("offcanvas", "offcanvas-end");
    c.id = "offCanvasHelp";
    const h = document.createElement('div');
    h.classList.add("offcanvas-header");
    const h5 = document.createElement('h5');
    h5.classList.add("offcanvas-title");
    const btn = document.createElement("button");
    btn.classList.add("btn-close", "text-reset");
    btn.setAttribute('data-bs-dismiss', 'offcanvas');
    btn.setAttribute('aria-label', 'Schliessen');
    const body = document.createElement('div');
    body.classList.add("offcanvas-body");
    const content = document.createElement('div');
    content.classList.add("offcanvas-content");

    const spinnerHolder = document.createElement('div');
    spinnerHolder.classList.add('text-center', 'mt-4')
    const spinner = document.createElement("div")
    spinner.classList.add('spinner-border')

    h.append(h5);
    h.append(btn);
    c.append(h);
    spinnerHolder.append(spinner);
    content.append(spinnerHolder)
    body.append(content);
    c.append(body);
    document.body.append(c);
  }
  const off = document.getElementById('offCanvasHelp');
  const bsOff = new bootstrap.Offcanvas(off);
  return bsOff;
}

export var showQuestion = function(questionId){
  const bs = createOffCanvas();
  bs.show();
  const config = {
    url: '/instruction/' + questionId.toString(),
    data: {
      // 'action': 'get_question_content',
      // 'questionId': questionId,
    },
    beforeSend: function(){
      // set offcanvas to loading
    },
    success: function(data){
      displayQuestionAnswer(data.headline, data.content);
    },
    error: function(error){
      errorToast("Anleitung konnte nicht geladen werden", "Fehler", 10000);
    }
  }
  ajaxSpin(config, $(".offcanvas-content").find("p"));

}

export var disableButton = function(btn, time=2500){
  btn.prop('disabled', true);
  setTimeout(function(){
    btn.prop('disabled', false);
  }, time)
}

export var goBackWithRefresh = function(){
  if ('referrer' in document) {
    window.location = document.referrer;
  } else {
    window.history.back();
  }
}

export var showSpinner = function(holder){
  const outside = document.createElement('div');
  outside.classList.add('spinner-outside');
  const spinner = document.createElement('div');
  spinner.classList.add('spinner-wrapper');
  const html = document.createElement('div');
  html.classList.add('spinner-border', 'text-primary');
  const span = document.createElement('span');
  span.classList.add('sr-only');
  span.innerHTML = 'Lädt...';
  html.append(span);
  spinner.append(html);
  outside.append(spinner);
  holder.append(outside);
  return spinner;
}

export var uniqid = function(length){
  let result           = '';
  const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() *
      charactersLength));
  }
  return result;
}

export var removeSpinner = function(holder){
  holder.find('.spinner-wrapper').remove();
};

const umlautMap = {
  '\u00dc': 'UE',
  '\u00c4': 'AE',
  '\u00d6': 'OE',
  '\u00fc': 'ue',
  '\u00e4': 'ae',
  '\u00f6': 'oe',
  '\u00df': 'ss',
}

function replaceUmlaute(str) {
  return str
    .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
      const big = umlautMap[a.slice(0, 1)];
      return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
    })
    .replace(new RegExp('[' + Object.keys(umlautMap).join('|') + ']', "g"),
      (a) => umlautMap[a]
    );
}

export var createButton = function(type, text, classes=''){
  const button = document.createElement('button');
  button.classList.add('btn', 'btn-light-'+type, 'text-'+type, 'font-weight-medium', 'waves-effect');
  $(button).addClass(classes);
  $(button).html(text);
  return button;
}

export var createLink = function(type, text, to, classes=''){
  const link = document.createElement('a');
  link.href = to;
  link.classList.add('btn', 'btn-light-'+type, 'text-'+type, 'font-weight-medium', 'waves-effect');
  $(link).addClass(classes);
  $(link).html(text);
  $(link).css('padding', '.375rem .75rem');
  return link;
}

export var changeUrl = function(end){
  const url = window.location.href;
  window.location.href = url.split('/').slice(0,-1).join('/') + '/' + end;
}


export var makeEditorModal = function(id, title, content, settings = {}, onclick=function(){}){
  const s = {};
  s.leftInput = (settings.leftInput !== undefined) ? settings.leftInput : {value: false, placeholder: '', text: ''};
  s.submitBtn = (settings.submitBtn !== undefined) ? settings.submitBtn : {};
  s.size = (settings.size !== undefined) ? settings.size : false;
  s.centered = (settings.centered !== undefined) ? settings.centered : true;
  s.closeBtn = (settings.close !== undefined) ? settings.close : false;
  s.draggable = (settings.draggable !== undefined) ? settings.draggable : true;
  s.fill = (settings.fill !== undefined) ? settings.fill : true; // if fill = false -> not reinitiated
  if (document.getElementById(id) != undefined){
    return editEditorModal(id, title, content, s.leftInput.value, s.fill);
  } else {
    let modal = `<div id="${id}" class="modal fade" role="dialog">
  <div class="modal-dialog`;
    if (s.size) {
      modal += ' modal-' + size;
    }
    if (s.centered){
      modal += ' modal-dialog-centered';
    }
    modal += `">
    <!-- Modal content-->
    <div class="modal-content">
        <div class="modal-header d-flex align-items-center border-bottom">
                <h4 class="modal-title">${title}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      <div class="modal-body">
        ${content}
      </div>
      <div class="modal-footer border-top">`;
    if (!jQuery.isEmptyObject(s.leftInput)){
      const width = (s.leftInput.width !== undefined) ? s.leftInput.width : '100px';
      modal += `<input type="${s.leftInput.type}" class="left-input boxen form-control form-control-lg" style="width: ${width};"`
      if (s.leftInput.value){
        modal += ` value="${s.leftInput.value}"`
      } else {
        modal += ` placeholder="${s.leftInput.placeholder}"`
      }
      modal += '>';
      if (s.leftInput.text){
        modal += ' <span class="ms-2">' + s.leftInput.text + '</span>';
      }
    }
    modal += '<div class="ms-auto">'
    if (s.close) {
      modal += `<button type="button" class="btn btn-info waves-effect" data-bs-dismiss="modal">Schließen</button>`;
    }
    if (!jQuery.isEmptyObject(s.submitBtn)) {
      const data = (s.submitBtn.data !== undefined) ? s.submitBtn.data : '';
      modal += `<button class="${s.submitBtn.class} btn btn-lg btn-light-success text-success font-weight-medium sub" type="button" ${data}>${s.submitBtn.text}</button>`;
    }
    modal += '</div>';
    modal += `</div>
        </div>
      </div>
    </div>`;
    $(document.body).append(modal);
    const m = document.getElementById(id);
    const myModal = new bootstrap.Modal(m, {
      keyboard: true,
      focus: true,
      backdrop: false,
    });
    myModal.show();

    // What to do on submit?
    const jM = $(m);
    const execute = function(){
      const check = onclick(this)
      if (check){
        myModal.hide();
      }
    };
    jM.on("click", ".sub", execute.bind(jM));
    // make draggable
    if (s.draggable){
      jM.find(".modal-content").draggable();
    }
    return myModal;
  }
}



export var editEditorModal = function(id, title, content, leftInputValue, fill=true){
  if (fill) {
    const modal = $("#" + id);
    modal.find(".modal-title").html(title);
    modal.find(".modal-body").html(content);
    if (leftInputValue) {
      modal.find(".left-input").val(leftInputValue);
    }
  }
  const existingModal = bootstrap.Modal.getInstance(document.getElementById(id));
  existingModal.show();
  return existingModal;
}

export var makeModal = function(id, title, content, submitBtn = {}, closeBtn = true, size:boolean|string=false, centered=false) {
  if (document.getElementById(id) != undefined){
    return editModal(id, title, content);
  } else {
    let modal = `<div id="${id}" class="modal fade" role="dialog">
  <div class="modal-dialog`;
    if (size) {
      modal += ' modal-' + size;
    }
    if (centered){
      modal += ' modal-dialog-centered';
    }
    modal += `">
    <!-- Modal content-->
    <div class="modal-content">
        <div class="modal-header d-flex align-items-center">
                <h4 class="modal-title">${title}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      <div class="modal-body">
        ${content}
      </div>
      <div class="modal-footer">`;
    if (closeBtn) {
      modal += `<button type="button" class="btn btn-info waves-effect" data-bs-dismiss="modal">Schließen</button>`;
    }
    if (!jQuery.isEmptyObject(submitBtn)) {
      const data = (submitBtn.data !== undefined) ? submitBtn.data : '';
      modal += `<button class="${submitBtn.class} btn btn-light-success text-success font-weight-medium" type="button" ${data}>${submitBtn.text}</button>`;
    }
    modal += `</div>
        </div>
      </div>
    </div>`;
    $(document.body).append(modal);
    const myModal = new bootstrap.Modal(document.getElementById(id));
    return myModal;
  }
}

export var editModal = function(id, title, content){
  const modal = $("#" + id);
  modal.find(".modal-title").html(title);
  modal.find(".modal-body").html(content);
  const existingModal = bootstrap.Modal.getInstance(document.getElementById(id));
  existingModal.show();
  return existingModal;
}

export var editExamModal = function(showText, id="exam-modal"){
  const modal = $("#" + id)
  modal.find(".show-text").html(showText);
  modal.show();
  return modal;
}

export var buildExamModal = function(showText, id="exam-modal"){
  if (document.getElementById(id) != undefined){
    return editExamModal(showText, id);
  } else {
    const html = `<div id="exam-modal" class="p-modal-container k-modal">
            <div class="p-modal-bg p-no-bg"></div>
            <div class="p-modal">
                <div class="p-inmodal p-modal-editor" style="max-width: 550px; max-height: 300px; height: auto;">
                    <div class="p-upload p-m-topic">
                        <div class="show-text">${showText}</div>
                        <p class="h-m-p"></p>
                    </div>
                </div>
            </div>
        </div>`;
    $(document.body).append(html);
    const modal = $("#" + id);
    $(".k-modal .p-inmodal").css("text-align", "center").css("font-size", "4vw");
    modal.show();
    return modal;
  }
}

export var hideExamModal = function(){
  const modal = editExamModal("");
  modal.hide()
}



function ajaxConf(config, btn){
  config.type = 'POST'
  config.dataType = 'json'
  if (btn) {
  //  config.beforeSend = showSpinner(btn)
    config.complete = hideSpinner(btn)
  }
  return config;
}

export function ajaxSpin(config:any, btn=false){
  $.ajax(ajaxConf(config, btn));
}

export var exportActiveUsers = function(courseId){
  window.open(pexam_ajax_object.site_url + "/pdf/?action=all_active_users&id=" + courseId, "_blank")
}

export var exportAnonymousUsers = function(courseId){
  window.open(pexam_ajax_object.site_url +  "/pdf/?action=anonym_users&id=" + courseId, "_blank");
}

/* Kurs-Verwaltung */



/* Tutor-Verwaltung */
export var fillBadges = function(userId, targetField, schoolId){
  const config = {
    data: {
      'action': 'fill_course_badges', //calls wp_ajax_nopriv_ajaxlogin
      'userId': userId,
      'instanceId': schoolId,
    }, // noch ersetzten durch pexam_ajax_object
    success: function(data){
      if (data.success){
        targetField.html(data.html);
      } else {
        errorMessage(".page-wrapper", "Anmeldung fehlgeschlagen");
      }
    }
  }
  ajax(config);
}

export var getCurrentTutorCourseIds = function(element):Array<number>{
  const tutor = tutorVerwaltungGetTutorFromButton(element);
  const courses = tutor.cell.parent().find(".t-info");
  const foundCourses = [];
  courses.each(function(ind, obj){
    foundCourses.push(parseInt(obj.getAttribute("data-course")));
  })
  return foundCourses;
}

export var tutorVerwaltungGetTutorFromBadge = function(element){
  const tutorCell = element.parent().parent().parent().children(":first");
  return {
    "id": tutorCell.attr("data-user"),
    "name": tutorCell.html()
  }
}

export var tutorVerwaltungGetTutorFromButton = function(element){
  const tutorCell = element.parent().parent().children(":first");
  return {
    "id": tutorCell.attr("data-user"),
    "name": tutorCell.html(),
    "cell": tutorCell
  }
}


export var removeCourseFromTutor = function(courseId, userId, badge){
  const config = {
    data: {
      'action': 'remove_course_from_tutor',
      'fachId': courseId,
      'userId': userId,
    },
    success: function(data){
      if (data.success){
        badge.remove();
        successToast("Kurs wurde von Tutor/-in entfernt","", 6500, true);
      } else {
        errorToast("Kurs konnte nicht von Tutor/-in entfernt werden", "Fehler", 0);
      }
    }
  }
  ajax(config);
}

export var removeNotAcceptedCourseFromTutor = function(courseId, userId, badge){
  const config = {
    data: {
      action: "deactivate_tutor_vormerkung",
      userId: userId,
      courseId: courseId,
    },
    success: function(data){
      if (data.success){
        badge.remove();
        successToast("Vormerkung wurde von Tutor/-in entfernt","", 6500, true);
      } else {
        errorToast("Vormerkung konnte nicht von Tutor/-in entfernt werden", "Fehler", 0);
      }
    }
  }
  ajax(config);
}





export var chooseListWithButtons = class chooseListWithButtons{

  constructor(wrapper, item, buttonClass){
    this.wrapper = wrapper;
    this.item = item;
    this.buttonClass = buttonClass;
    this.plusClasses = "btn-light-success text-success";
    this.minusClasses = "btn-light-danger text-danger";
    this.positiveIcon = "fa-plus-circle";
    this.negativeIcon = "fa-minus-circle";


    this.data = [];
    this.dataName = 'fach';

    this.addListeners();

  }
  addListeners(){
    const handler = this;
    $(this.wrapper).on("click", this.item, function(){
      const button = $(this).find(handler.buttonClass);
      const chosen = parseInt(button.attr("data-chosen"));

      const item = $(this);
      const icon = $(this).find("i");

      if (chosen != 1){
        item.addClass("chosen");
        button.attr('data-chosen', 1);
        icon.addClass(handler.negativeIcon).removeClass(handler.positiveIcon);
        button.removeClass(handler.plusClasses).addClass(handler.minusClasses);
      } else {
        item.removeClass("chosen");
        button.attr('data-chosen', 0);
        icon.addClass(handler.positiveIcon).removeClass(handler.negativeIcon);
        button.addClass(handler.plusClasses).removeClass(handler.minusClasses);
      }
    })
  }

  turnItemPositive(item){
    const button = item.find(this.buttonClass);
    const icon = item.find("i");
    item.addClass("chosen");
    button.attr('data-chosen', 1);
    icon.addClass(this.negativeIcon).removeClass(this.positiveIcon);
    button.removeClass(this.plusClasses).addClass(this.minusClasses);
  }

  getData(){
    const handler = this;
    const data = [];
    const chosen = $(`${this.wrapper} ${this.item}.chosen ${this.buttonClass}`)
    chosen.each(function(ind, obj){
      const courseId = $(obj).attr(`data-${handler.dataName}`);
      data.push(courseId);
    });
    return data;
  }

  resetData(){
    const items = $(`${this.wrapper} ${this.item}`);
    items.removeClass("chosen");
    const buttons = $(`${this.wrapper} ${this.buttonClass}`);
    buttons.attr('data-chosen', 0);
    buttons.addClass(this.plusClasses).removeClass(this.minusClasses);
    const icons = buttons.find("i");
    icons.removeClass(this.negativeIcon).addClass(this.positiveIcon);
  }
}

export var NewTutorActivator = class NewTutorActivator {
  constructor() {
    this.chooseList = new chooseListWithButtons(".new-tutor-wrapper", ".m-f-t-item", ".add-course-to-be-activated");
    const self = this;
    $(document).on("click", ".activate-new-tutor-for-course", function(){
      const email = $("#new-tutor-mail").val();
      const check = checkEmail(email);
      const courses = self.chooseList.getData();

      if (!check || email == ''){
        errorToast('Bitte gib eine gültige Mail ein', 'Fehler', 15000, true);
      } else if (courses.length < 1){
        errorToast('Bitte wähle mindestens einen Kurs aus', 'Fehler', 15000, true);
      } else {
        activateNewTutorForCourses(email, courses, self.chooseList, $(this), false);
      }
    });
  }
}

export var CourseCreator = class CourseCreator{
  constructor() {
    this.addListeners();
  }
  addListeners(){
    $(document).on("click", ".create-course", function(){
      createCourse(0, $(this));
    })
  }
}

export var getJson = function(JsonInput, reverse=true){
  let input = JSON.parse(JsonInput);
  if (reverse){
    input = input.reverse();
  }
  return input;
}

export var loadAb = function(abId, active=true){
  if (active){
    window.open(pexam_ajax_object.site_url + '/ab/?code=' + abId, '_blank');
  } else {
    errorToast("Dieses AB muss erst aktiviert werden", "Fehler", 0);
  }
}

export var getSearchParam = function(needle, error=false){
  const urlParams = new URLSearchParams(window.location.search);
  const param = urlParams.get(needle);
  if (param !== undefined && param !== '' && param !== null){
    return param;
  } else {
    return error;
  }
}

export var showBlock = function(blockId, btn=false, lastBlockId=false){
  let url = 'lernblock?block=' + blockId;
  if (lastBlockId){
    url += '&last=' + lastBlockId;
  }
  if (btn){
    showSpinner(btn)
  }
  window.location = pexam_ajax_object.site_url + '/' + url;
  if (btn){
    setTimeout(() => {
      hideSpinner(btn);
    }, 1500);
  }
}

export var displayQrCode = function(code, path='https://rechtschreibtrainer.de/ab/'){
  const content = '<div id="qr-code-wrapper text-center">'+
    '<div class="row">'+
    '<div class="col-sm-4">'+
    '<div id="qrcode"></div>'+
    '</div>'+
    '<div class="col-sm-8">'+
    '<h3>Code: </h3>' +
    '<p>Schüler/-innen können mit dem Code <b>' + code.replace("/use", "") + '</b> direkt auf das AB zugreifen</p>' +
    '<h3>Link: </h3>'+
    '<p id="code-url" class="user-select-all"></p>'+
    '</div>'+
    '</div>'+
    '</div>';
  const submitBtn  = {
    class: 'download-qr',
    text: 'Herunterladen'
  }
  const modal = makeModal('ab-qr-code', 'QR-Code zum Teilen', content, submitBtn, true, 'md');
  modal.show();
  const url = path + code;
  $("#code-url").html(url);
  const qrcode = new QRCode("qrcode",{
    text: url,
    width: 128,
    height: 128,
  });
}